module.exports = __webpack_public_path__ + "assets/img/dnormal.17985233.svg";